import { Module } from "../types";

export const modulesMockData: Module[] = [
    {
        id: "1",
        title: "DeepPCB",
        status: "Available",
        createdBy: "InstaDeep",
        tags: [{ id: "1", name: "PCB Layout", type: "InProgress" }, { id: "2", name: "PCB Layout", type: "Uploading" }, { id: "3", name: "PCB Layout", type: "InProgress" }, { id: "4", name: "Hardware Design", type: "InProgress" }],
    },
    {
        id: "2",
        title: "DeepPack",
        status: "Available",
        createdBy: "InstaDeep",
        tags: [{ id: "1", name: "PCB Layout", type: "InProgress" }, { id: "2", name: "PCB Layout", type: "Uploading" }, { id: "3", name: "PCB Layout", type: "InProgress" }, { id: "4", name: "Hardware Design", type: "InProgress" }],
    },
    {
        id: "3",
        title: "DeepAirport",
        status: "Available",
        createdBy: "InstaDeep",
        tags: [{ id: "1", name: "PCB Layout", type: "InProgress" }, { id: "2", name: "PCB Layout", type: "Uploading" }, { id: "3", name: "PCB Layout", type: "InProgress" }, { id: "4", name: "Hardware Design", type: "InProgress" }],
    },
    {
        id: "4",
        title: "DeepPCB",
        status: "Available",
        createdBy: "InstaDeep",
        tags: [{ id: "1", name: "PCB Layout", type: "InProgress" }, { id: "2", name: "PCB Layout", type: "Uploading" }, { id: "3", name: "PCB Layout", type: "InProgress" }, { id: "4", name: "Hardware Design", type: "InProgress" }],
    },
    {
        id: "5",
        title: "DeepPCB",
        status: "Available",
        createdBy: "InstaDeep",
        tags: [{ id: "1", name: "PCB Layout", type: "InProgress" }, { id: "2", name: "PCB Layout", type: "Uploading" }, { id: "3", name: "PCB Layout", type: "InProgress" }, { id: "4", name: "Hardware Design", type: "InProgress" }],
    },
    {
        id: "6",
        title: "DeepPCB",
        status: "Available",
        createdBy: "InstaDeep",
        tags: [{ id: "1", name: "PCB Layout", type: "InProgress" }, { id: "2", name: "PCB Layout", type: "Uploading" }, { id: "3", name: "PCB Layout", type: "InProgress" }, { id: "4", name: "Hardware Design", type: "InProgress" }],
    }
];